export function initGrandAngleModal() {
  // enableLinkTracking n'écoute que les liens présents au chargement : le clic
  // qui ouvre la modale partirait en outlink alors que personne ne sort, et le
  // lien réel, injecté par showModal, ne serait jamais compté. La classe éteint
  // le premier ; le trackLink du CTA de la modale compte le second.
  document
    .querySelectorAll('a[href*="grandangle"]')
    .forEach((a) => a.classList.add("matomo_ignore"));

  document.addEventListener("click", (e) => {
    const link = e.target.closest("a[href]");
    if (!link) return;
    if (link.classList.contains("ga-modal-cta")) return;

    if (!link.href.includes("grandangle")) return;

    e.preventDefault();
    e.stopPropagation();
    showModal(link.href);
  });
}

function showModal(url) {
  window._paq &&
    window._paq.push(["trackEvent", "Partner", "GA modal opened", location.pathname]);

  const overlay = document.createElement("div");
  overlay.className =
    "fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4";
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-labelledby", "ga-modal-title");

  overlay.innerHTML = `
    <div class="prose relative mx-auto max-w-lg rounded-2xl bg-white p-8 shadow-2xl">
      <button type="button" aria-label="Fermer"
        class="ga-modal-close absolute top-3 right-3 text-2xl leading-none text-gray-400 hover:text-gray-700 no-underline">&times;</button>
      <h2 id="ga-modal-title" class="mb-4 text-xl font-bold text-gray-900">Découvrez les séjours Grand Angle</h2>
      <p class="mb-5 text-gray-700">Nos séjours guidés affichent souvent complet. Si les dates qui vous intéressent ne sont plus disponibles chez Altimood, nous vous invitons à découvrir les départs programmés par l'agence de trekking <strong>Grand Angle</strong>.</p>
      <div class="mb-6 rounded-lg bg-amber-50 border border-amber-200 px-5 py-4 text-left">
        <p class="text-sm text-amber-800 mb-1">Code promo</p>
        <span class="inline-block rounded bg-amber-200 px-3 py-1 font-mono text-lg font-bold tracking-wider text-amber-900">ALTIMOOD</span>
        <p class="mt-2 text-sm text-amber-700">= frais de dossier offerts</p>
      </div>
      <a href="${url}" target="_blank" rel="noopener"
        class="ga-modal-cta link-btn link-btn-orange block w-full py-3 text-center font-semibold text-white no-underline">Continuer vers Grand Angle →</a>
    </div>
  `;

  const close = () => {
    overlay.remove();
    document.removeEventListener("keydown", onKeydown);
  };

  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) close();
  });
  overlay.querySelector(".ga-modal-close").addEventListener("click", close);
  overlay.querySelector(".ga-modal-cta").addEventListener("click", () => {
    // trackLink à la main : le lien n'existait pas quand enableLinkTracking a
    // posé ses écouteurs, la sortie réelle serait invisible du rapport Outlinks.
    if (window._paq) {
      window._paq.push(["trackEvent", "Partner", "GA continue", location.pathname]);
      window._paq.push(["trackLink", url, "link"]);
    }
    close();
  });

  const onKeydown = (e) => {
    if (e.key === "Escape") close();
  };
  document.addEventListener("keydown", onKeydown);

  document.body.appendChild(overlay);
  overlay.querySelector(".ga-modal-close").focus();
}
